//HOME 
export const attendanceCards = [
  {
    company: 'Sancor',
    companyAlt : 'Sancor',
    link : 'https://www.sancorseguros.com.ar/',
    companyImg: 'https://natalfwk.gruposancorseguros.com/nf-institucional/3.0.1/doc/imgs/logo.svg',
    data: [
      {
        logo: '/icons/phone.png',
        title: 'Denuncia de Siniestros Automotor:',
        subtitle: '0800 777 4643'
      },
      {
        logo: '/icons/phone.png',
        title: 'Emergencias médicas (integro): ',
        subtitle: '0800 555 2850'
      },
      {
        logo: '/icons/phone.png',
        title: 'Asistencia al vehículo y personas:',
        subtitle: '0800 333 2766'
      },
    ],
  },
  // {
  //   company: 'Cio',
  //   companyImg: '/logos/allianz.png',
  //   data: [
  //     {
  //       logo: '/icons/phone.png',
  //       title: 'Consultas y reclamos ART: ',
  //       subtitle: '0-800-999-4652'
  //     },
  //     {
  //       logo: '/icons/phone.png',
  //       title: 'Asistencia automotor: ',
  //       subtitle: '0-800-999-0002'
  //     },
  //     {
  //       logo: '/brands/whatsapp.png',
  //       title: 'Asistencia Embarcaciones: ',
  //       subtitle: '+54 911-3251-222'
  //     }
  //   ],
  // },
  {
    company: 'La Holando',
    companyAlt : 'La Holando',
    link : 'https://www.laholando.com/',
    companyImg: '/logos/laHolando-con-fondo.jpg',
    data: [
      {
        logo: '/icons/phone.png',
        title: 'Emergencias ART:',
        subtitle: '0-800-999-9719'
      },
      {
        logo: '/icons/phone.png',
        title: 'Asistencia automotor',
        subtitle: '0-800-999-0002'
      },
      {
        logo: '/icons/phone.png',
        title: 'Teléfono:',
        subtitle: '4321-7600'
      }
    ],
  },
  {
    company: 'Prevencion Art',
    link :  'https://www.prevencionart.com.ar/',
    companyAlt : 'Prevencion',
    companyImg: 'https://www.prevencionart.com.ar/resources/ART_color.svg',
    data: [
      {
        logo: '/icons/phone.png',
        title: 'Emergencias médicas:',
        subtitle: '0800 4444 278'
      },
      {
        logo: '/icons/phone.png',
        title: 'Consultas:',
        subtitle: '0800 5555 278'
      },
      {
        logo: '/brands/whatsapp.png',
        title: 'Consultas vía WhatsApp:',
        subtitle: '3493 66 1916'
      }
    ]
  }
]

export const skills = [
  {
    imgSrc: '/icons/insurance.png',
    title: 'Asegurados',
    description: 'Nuestros clientes cuentan con un servicio personalizado y especializado lo cual genera relaciones de largo plazo',
    alt: 'Chat image',
    id: 0
  },
  {
    imgSrc: '/icons/administrative.png',
    title: 'Administración de riesgos',
    description: 'Nos ocupamos de la cotización, comparación, contratación, actualización y renovación de tus pólizas',
    alt: 'Skills image',
    id: 1
  },
  {
    imgSrc: '/icons/innovation.png',
    title: 'Innovación',
    description: 'Contamos con un innovador sistema de gestión de pólizas con un rápido acceso en la misma página',
    alt: 'Graphic image',
    id: 2
  },
  {
    imgSrc: '/icons/academic.png',
    title: 'Capacitación y asesoramiento',
    description: 'Mediante unos simples pasos visualizarás todas tus pólizas y las podrás descargar y compartir ',
    alt: 'Tools image',
    id: 3
  }
]

export const contactInputs = [
  {
    name: 'user_name',
    title: 'Nombre completo',
    placeHolder: 'Escribe tu nombre',
    minlength: '1',
    maxlength: '30',
    required: true,
    width: 'w-full',
  },
  {
    name: 'user_email',
    title: 'Email',
    placeHolder: 'example@email.com...',
    type: 'email',
    minlength: '8',
    maxlength: '48',
    required: true,
    width: 'w-full',
  },
]

// Navigation links for the desktop version of the website
export const desktop_navLinks = [
  {
    title: 'Útiles', // Title of the navigation link
    scroll: '#attendance', // Section ID to scroll to
    offset: 100 // Scroll offset (in pixels)
  },
  {
    title: 'Contacto',
    scroll: '#contact',
    offset: 100
  },
  {
    title: 'Nosotros',
    scroll: '#about',
    offset: 150
  }
]

// Navigation links for the mobile version of the website
export const mobile_navLinks = [
  {
    title: 'Útiles',
    scroll: '#attendance',
    offset: 0
  },
  {
    title: 'Contacto',
    scroll: '#contact',
    offset: 0
  },
  {
    title: 'Nosotros',
    scroll: '#about',
    offset: 0
  }
]

// List of brokers with their details (name, description, and ID)
export const brokers = [
  {
    name: 'Nicolas', // Broker name
    description: 'doloe lorem fnisadioasnd ajsdnioasdka dasnda asdnas dnasd', // Broker description
    id: 0, // Unique identifier for the broker
  },
  {
    name: 'Nahuel',
    description: 'description description descriptionvv description descriptiondescription',
    id: 1
  }
]

// Companies associated with each broker (Nicolas and Nahuel)
export const _companys = {
  Nicolas: [
    {
      imgSrc: '/logos/sancor-con-fondo.png',
      value: 'Sancor', // Name of the insurance company
      db: 'Sancor', // Database name
      isSelected: false, // Whether the company is selected
      id: 0 // Unique identifier for the company
    },
    {
      imgSrc: '/logos/laHolando-con-fondo.jpg',
      value: 'La Holando',
      db: 'LaHolando',
      isSelected: false,
      id: 1
    },
  ],
  Nahuel: [
    {
      imgSrc: '/logos/sancor-con-fondo.png',
      value: 'Sancor',
      db: 'Sancor',
      isSelected: false,
      id: 0
    }
  ]
}

// Types of insurance available for each broker (Nicolas and Nahuel)
export const InsurancesType = {
  Nicolas: [ 
    {
      title: 'Incendio', // Insurance type title
      url: '/insuranceTypes/incendio.jpeg', // URL to the insurance image
      iType: {
        sancor : 300,
        laHolando: 1, // Insurance type ID for La Holando
        title: 'Incendio' // Insurance type title
      },
      id: 0
    },
    {
      title: 'Combinados',
      url: '/insuranceTypes/combinados.jpeg',
      iType: {
        sancor: 1800,
        laHolando: 2,
        title: 'Combinados'
      },
      id: 1
    },
    {
      title: 'Automóviles',
      url: '/insuranceTypes/automotores.jpeg',
      iType: {
        sancor: 200,
        laHolando: 3,
        title: 'Automóviles'
      },
      id: 2
    },
    {
      title: 'Granizo',
      url: '/insuranceTypes/granizo.jpeg',
      iType: {
        sancor: 900,
        laHolando: 7,
        title: 'Granizo'
      },
      id: 3
    },
    {
      title: 'Resp Civil',
      url: '/insuranceTypes/respCivil.jpeg',
      iType: {
        sancor: 1500,
        laHolando: 8,
        title: 'Resp Civil'
      },
      id: 4
    },
    {
      title: 'Seguro técnico',
      url: '/insuranceTypes/segTecnico.jpeg',
      iType: {
        sancor: 1400,
        laHolando: 16,
        title: 'Seguro técnico'
      },
      id: 5
    },
    {
      title: 'Cascos',
      url: '/insuranceTypes/cascos.jpeg',
      iType: {
        sancor: 1000,
        laHolando: 18,
        title: 'Cascos'
      },
      id: 6
    },
    {
      title: 'Transporte',
      url: '/insuranceTypes/transporte.jpeg',
      iType: {
        sancor: 500,
        laHolando: 19,
        title: 'Transporte'
      },
      id: 7
    },
    {
      title: 'P. & I.',
      url: '/insuranceTypes/p&l.jpeg',
      iType: {
        // sancor: 200,
        laHolando: 18,
        title: 'P. & I.'
      },
      id: 8
    },
    // {
    //   title: 'ART',
    //   url: '/insuranceTypes/art.jpeg',
    //   iType: {
    //     title: 'ART',
    //     sancor: 600,
    //     laHolando: 18,
    //   },
    //   id: 9
    // }
  ],
  Nahuel: [
    {
      title: 'Incendio',
      url: '/insuranceTypes/incendio.jpeg',
      iType: {
        sancor : 300,
        title: 'Incendio'
      },
      id: 0
    },
    {
      title: 'Combinados',
      url: '/insuranceTypes/combinados.jpeg',
      iType: {
        sancor: 1800,
        title: 'Combinados'
      },
      id: 1
    },
    {
      title: 'Automóviles',
      url: '/insuranceTypes/automotores.jpeg',
      iType: {
        sancor: 200,
        title: 'Automóviles'
      },
      id: 2
    },
    {
      title: 'Granizo',
      url: '/insuranceTypes/granizo.jpeg',
      iType: {
        sancor: 900,
        title: 'Granizo'
      },
      id: 3
    },
    {
      title: 'Resp Civil',
      url: '/insuranceTypes/respCivil.jpeg',
      iType: {
        sancor: 1500,
        title: 'Resp Civil'
      },
      id: 4
    },
    {
      title: 'Seguro técnico',
      url: '/insuranceTypes/segTecnico.jpeg',
      iType: {
        sancor: 1400,
        title: 'Seguro técnico'
      },
      id: 5
    },
    {
      title: 'Cascos',
      url: '/insuranceTypes/cascos.jpeg',
      iType: {
        sancor: 1000,
        title: 'Cascos'
      },
      id: 6
    },
    {
      title: 'Transporte',
      url: '/insuranceTypes/transporte.jpeg',
      iType: {
        sancor: 500,
        title: 'Transporte'
      },
      id: 7
    },
    // {
    //   title: 'P. & I.',
    //   url: '/insuranceTypes/p&l.jpeg',
    //   iType: {
    //     sancor: 200,
    //     title: 'P. & I.'
    //   },
    //   id: 8
    // },
    // {
    //   title: 'ART',
    //   url: '/insuranceTypes/art.jpeg',
    //   iType: {
    //     title: 'ART'
    //   },
    //   id: 9
    // }
  ]
}

// Login input fields for the login form
export const loginInput = {
  name: 'email',
  title: 'Email',
  placeHolder: 'example@email.com...',
  type: 'email',
  minlength: '1',
  maxlength: '40',
  required: true,
  width: 'w-full'
}

// Button style types for various actions
export const buttonsTypes = {
  primary: "border-primary bg-primary text-white active:bg-primary", // Primary button style
  primaryLight: "border-purple-200 bg-purple-100 text-primary hover:bg-purple-200 active:bg-purple-200", // Light primary button style
  secondary: "border-secondary bg-secondary text-black hover:bg-secondary active:bg-secondary", // Secondary button style
  secondaryLight: "border-yellow-200 bg-yellow-100 text-yellow-900 hover:bg-yellow-200 active:bg-yellow-100", // Light secondary button style
  light: "border-gray-100 bg-white text-gray-800 hover:bg-gray-100 active:bg-gray-100", // Light button style
  dark: "border-black bg-black text-white hover:bg-gray-950 active:bg-black-500", // Dark button style
  success: "border-green-200 bg-green-100 text-green-800 hover:bg-green-200 active:bg-green-200", // Success button style
  error: "border-red-200 bg-red-100 text-red-800 hover:bg-red-200 active:bg-red-200", // Error button style
  disabled: "border-gray-200 bg-gray-200 text-gray-600", // Disabled button style
}
